export async function submitFpForReview({ backendUrl, payload, files = [] }) {
  const fd = new FormData();
  fd.append("payload", JSON.stringify(payload || {}));

  (files || []).forEach((f) => fd.append("files", f));

  const res = await fetch(`${backendUrl}/fp/submit`, {
    method: "POST",
    body: fd,
  });

  let json = {};
  try {
    json = await res.json();
  } catch {
    json = {};
  }

  if (!res.ok) {
    throw new Error(json?.error || "Submit failed");
  }

  return json;
}
